import { RedocStandalone } from 'redoc'
import { theme } from './Theme'

function App() {
  const basePath = process.env.REACT_APP_SPEC_BASE_URL || window.location.origin

  return (
    < RedocStandalone
      specUrl={`${basePath}/jsons/api.json`}
      options={{theme}}
    />
  )
}

export default App
